import styled from "styled-components";

export const Wrapper = styled.div`
  padding: 0px 20px 20px 20px;
  .wrap {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    padding-top: 20px;
    gap: 10px;
    .date-title {
      font-family: Inter;
      font-size: 15px;
      font-weight: 400;
      line-height: 15px;
      color: #8490a5;
    }
    .card {
      width: 100%;
    }
    .date {
      font-family: Inter;
      font-size: 17px;
      font-weight: 600;
      line-height: 17px;
      color: #343c6a;
      padding-top: 10px;
    }
  }
  .desc {
    width: 100%;
    padding-top: 20px;
    .date-title {
      font-family: Inter;
      font-size: 15px;
      font-weight: 400;
      line-height: 15px;
      color: #8490a5;
    }
    .date {
      font-family: Inter;
      font-size: 17px;
      font-weight: 600;
      line-height: 17px;
      color: #343c6a;
      padding-top: 10px;
    }
  }
`;
